module.exports = __webpack_public_path__ + "img/banner-01.5556f7ad.jpg";